<template>
  <div class="contact" >
    <img
      class="contact-banner"
      :style="{ width: $store.state.fullWidth + 'px' }"
      src="../../assets/images/contact.png"
      alt=""
    />
    <div class="content">
      <div class="title">{{ $t("contact.title") }}</div>
      <div class="subtitle">{{ $t("contact.subtitle") }}</div>
      <div class="common-flex content-touch-input">
        <span class="iconfont iconxingming"></span>
        <input type="text" v-model='sendForm.customerName' :placeholder="$t('contact.name')" />
      </div>
      <div class="common-flex content-touch-input">
        <span class="iconfont iconyouxiang"></span>
        <input type="text" v-model='sendForm.customerEmail' :placeholder="$t('contact.e-mail')" />
      </div>
      <div class="common-flex content-touch-textarea">
        <span class="iconfont iconneirong"></span>

        <textarea
          name=""
          id=""
          v-model='sendForm.content'
          class="textarea"
          :placeholder="$t('contact.massage')"
          style="width: 680px; height: 120px"
        ></textarea>
      </div>
      <div class="send common-hover" @click="handleSend">{{ $t("contact.send") }}</div>
    </div>
  </div>
</template>

<script>
import { sendSubmit } from '@/api/contect.js'
export default {
  name: "contect",
  data() {
    return {
      sendForm:{
        content: "",
        customerEmail: "",
        customerName: ""
      }
    };
  },
  methods:{
    handleValidate(){
      var emailReg = /^\w+((.\w+)|(-\w+))@[A-Za-z0-9]+((.|-)[A-Za-z0-9]+).[A-Za-z0-9]+$/
      if(!this.sendForm.customerName){
        this.$Message.error(`${this.$t('contect.please')}${this.$t('contact.name')}`)
        return false
      }
      if(!this.sendForm.customerEmail){
        this.$Message.error(`${this.$t('contect.please')}${this.$t('contact.e-mail')}`)
        return false
      }else{
        if(!emailReg.test(this.sendForm.customerEmail)){
          this.$Message.error(`${this.$t('contact.e-mail')}${this.$t('contect.incorrect')}`)
          return false
        }
      }
      if(!this.sendForm.content){
        this.$Message.error(`${this.$t('contect.please')}${this.$t('contact.massage')}`)
        return false
      }
      return true
    },

    async handleSend(){
      let isEmpty = this.handleValidate()
      if(!isEmpty){
        return false
      }
      try{
        let { data } = await sendSubmit(this.sendForm)
        if(data.code === 0){
          this.$Message.success(`${this.$t('contect.success')}`)
          this.sendForm = {
            content: "",
            customerEmail: "",
            customerName: ""
          }
        }
      }catch(error){
        this.$Message.error(`${error.message}`)
      }
    }
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="less">
.contact {
  background: #fff;
  // min-height: 100vh;
  .contact-banner {
    display: block;
    margin-bottom: 20px;
  }
  .content {
    width: 680px;
    margin: 0 auto 0;
    padding-bottom: 60px;
    .send {
      width: 105px;
      height: 41px;
      opacity: 1;
      background: #081938;
      line-height: 41px;
      font-size: 12px;
      font-weight: 500;
      text-align: center;
      color: #ffffff;
      line-height: 41px;
      margin-top: 20px;
    }
  }

  .content-touch-textarea {
    width: 680px;
    height: 160px;
    background: #f8f8f8;
    margin-bottom: 20px;
    padding: 14px;
    display: flex;
    align-items: flex-start;
  }
  .iconneirong {
    font-size: 20px;
    margin-right: 5px;
    margin-top: -5px;
  }
  textarea[class="textarea"]::-webkit-input-placeholder {
    font-family: Roboto;
  }
  textarea {
    outline-color: invert;
    outline-style: none;
    outline-width: 0px;
    border: none;
    border-style: none;
    text-shadow: none;
    -webkit-appearance: none;
    -webkit-user-select: text;
    outline-color: transparent;
    box-shadow: none;
    background: #f8f8f8;
    resize: none;
  }
  .content-touch-input {
    width: 857px;
    height: 20px;
    background: #f8f8f8;
    margin-bottom: 20px;
    padding: 14px;
    align-items: center;
  }

  input {
    outline-color: invert;
    outline-style: none;
    outline-width: 0px;
    width: 800px;
    border: none;
    border-style: none;
    text-shadow: none;
    -webkit-appearance: none;
    -webkit-user-select: text;
    outline-color: transparent;
    box-shadow: none;
    background: #f8f8f8;
  }
  .title {
    margin-bottom: 12px;
    font-size: 20px;
    font-weight: 700;
    text-align: left;
    color: #081938;
    line-height: 24px;
  }
  .subtitle {
    margin-bottom: 20px;
    font-size: 12px;
    font-weight: 300;
    text-align: left;
    color: #081938;
    line-height: 14px;
  }
  .content-touch-input {
    width: 680px;
    height: 36px;
    background: #f8f8f8;
    margin-bottom: 20px;
    padding: 14px;
    align-items: center;
    .iconfont {
      font-size: 20px;
      margin-right: 5px;
    }
  }

  input {
    outline-color: invert;
    outline-style: none;
    outline-width: 0px;
    height: 36px;
    line-height: 36px;
    width: 680px;
    border: none;
    border-style: none;
    text-shadow: none;
    -webkit-appearance: none;
    -webkit-user-select: text;
    outline-color: transparent;
    box-shadow: none;
    background: #f8f8f8;
  }
}
</style>



// WEBPACK FOOTER //
// src/views/contect/contect.vue